module.exports = __webpack_public_path__ + "img/georgia-logo-icon.ec2b9e30.png";